import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'answerTypePipe'
})
export class AnswerStatusPipe implements PipeTransform {

  private listObj = {
    0: 'Text',
    1: 'SCQ',
    2: 'MCQ',
  };

  transform(value: number): string {
    console.log("transforming: ", value)
    return this.listObj.hasOwnProperty(value) ? this.listObj[value] : '';
  }

}
